import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { debounce } from './utilities'

gsap.registerPlugin(SplitText)

export const initSplitText = () => {
  const split = SplitText.create('[data-split]', {
    type: 'lines',
    linesClass: 'line++',
    mask: 'lines'
  })

  const splitChars = SplitText.create('[data-split-chars]', {
    type: 'chars',
    charsClass: 'char++',
  })

  const splitChildren = SplitText.create('[data-split-children] *', {
    type: 'lines, words, chars',
    charsClass: 'char++',
  })
}

export default () => { } 